export default "__VITE_ASSET__BSah2JVd__"